import { useTranslation } from 'react-i18next';

const CancelProtectionModalBody = () => {
  const { t } = useTranslation();

  return (
    <>
      <p>{t('pageScreenAndProtect.currentPage.cancelConfirmation.body')}</p>
      <ul>
        <li>
          {t(
            'pageScreenAndProtect.currentPage.cancelConfirmation.bulletNewBookings',
            { date: new Date() },
          )}
        </li>
        <li>
          {t(
            'pageScreenAndProtect.currentPage.cancelConfirmation.bulletScreenedBookings',
          )}
        </li>
        <li>
          {t(
            'pageScreenAndProtect.currentPage.cancelConfirmation.bulletPermanent',
          )}
        </li>
      </ul>
    </>
  );
};

export default CancelProtectionModalBody;
